const MonthToString = (month) => {
    let monthString = month.toString()
        monthString = monthString.length == 1 ? `0${monthString}` :  monthString
        return monthString
}

export default MonthToString;